import React from "react";

interface InstagramShareButtonProps {
  url?: string;
  children: React.ReactNode;
  [key: string]: any;
}

const InstagramShareButton: React.FC<InstagramShareButtonProps> = ({
  url,
  children,
  ...props
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.open(
      "https://www.instagram.com/kcoverseasofficial/",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <a
      href="https://www.instagram.com/kcoverseasofficial/"
      onClick={handleClick}
      style={{ display: "inline-block", cursor: "pointer", textDecoration: "none" }}
      {...props}
    >
      {children}
    </a>
  );
};

export default InstagramShareButton;
